<template>
  <div :class="stepNumber == 0 ? 'block' : 'hidden'">
    <input type="hidden" name="person[0][facebook_id]" :value="facebookId" />
    <h1 class="registration-form-layout__title">{{ subscriptionsFormTitle }}</h1>

    <div class="registration-form registration-form-layout flex" >

      <h3 class="registration-form-layout__block-title">{{ businessTitle }}</h3>

      <theme-toggler
        @click="triggerBusinessForm"
        :name="'business-registration'"
        :label="businessLabel"
        :value="business_state"
      ></theme-toggler>

      <div id="business-form" class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7" v-if="business_state == '1'">
        <theme-input
          :label="companyName"
          :name="companyNameInput"
          v-validate="`required`" 
          :isRequired="true"
          :placeholder="companyNamePlaceholder"
        ></theme-input>

        <theme-input
          :label="companyLegalForm"
          :name="companyLegalFormInput"
          v-validate="`required`"
          :isRequired="true"
          :placeholder="companyLegalFormPlaceholder"
        ></theme-input>

        <theme-input
          :label="companyChamberOfCommerceNumber"
          :name="companyChamberOfCommerceNumberInput"
          :placeholder="companyChamberOfCommerceNumberPlaceholder"
        ></theme-input>
        
        <theme-input
          :label="companyVatNumber"
          :name="companyVatNumberInput"
          :placeholder="companyVatNumberPlaceholder"
        ></theme-input>

        <theme-input
          :label="companyPhoneNumber"
          :name="companyPhoneNumberInput"
          :placeholder="companyPhoneNumberPlaceholder"
        ></theme-input>

        <theme-input
          :label="companyEmail"
          :name="companyEmailInput"
          :placeholder="companyEmailPlaceholder"
        ></theme-input>

        <theme-input
          :label="companyInvoiceEmail"
          :name="companyInvoiceEmailInput"
          :placeholder="companyInvoiceEmailPlaceholder"
        ></theme-input>
      </div>

      <h3 class="registration-form-layout__block-title" v-if="business_state == '0'">{{ subscriptionsYourRentalPreferences }}</h3>

      <div class="flex flex-col gap-4 md:gap-6" id="personal-form" v-if="business_state == '0'">
        <!-- :hide-label="true" -->
        <theme-radios
          :label="subscriptionsFamilyTypeInputTitle"
          :name="subscriptionsFamilyTypeInput"
          :options="subscriptionsFamilyTypeOptions"
          v-validate="`required|make_choice`"
          @input="triggerFamilyType"
          :isRequired="true"
        ></theme-radios>

        <theme-input
          v-if="family_type_state == 'several_friends'"
          name="number_of_adults"
          :placeholder="subscriptionNumberOfAdultsPlaceholder"
          :label="subscriptionNumberOfAdults"
          v-model.number="number_of_adults_value"
          v-validate="`required|numeric|min_value:0|max_value:5`"
          :isRequired="true"
          @input="triggerAdultsNumber"
        ></theme-input>
        </div>

      <h3 class="registration-form-layout__block-title">{{ subscriptionsYourDetails }}</h3>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
        <theme-input
          :label="subscriptionsFirstName"
          :name="subscriptionsFirstNameInput"
          :placeholder="subscriptionsFirstNamePlaceholder"
          :value="firstName"
          v-validate="`required`"
          :isRequired="true"
        ></theme-input>

        <theme-input
          :label="subscriptionsMiddleName"
          :name="subscriptionsMiddleNameInput"
          :placeholder="subscriptionsMiddleNamePlaceholder"
        ></theme-input>

        <theme-input
          :label="subscriptionsLastName"
          :name="subscriptionsLastNameInput"
          :placeholder="subscriptionsLastNamePlaceholder"
          :value="lastName"
          v-validate="`required`"
          :isRequired="true"
        ></theme-input>
        
        <theme-calendar
          :label="subscriptionsDateOfBirth"
          :name="subscriptionsDateOfBirthInput"
          v-validate="`required`"
          :placeholder="subscriptionsDateOfBirthPlaceholder"
          :isRequired="true"
        ></theme-calendar>
      </div>

      <div>

        <theme-input
          :label="subscriptionsPhoneNumber"
          class="js-unique-phone"
          :name="subscriptionsPhoneNumberInput"
          :placeholder="subscriptionsPhoneNumberPlaceholder"
          v-validate="`required|phone_number`"
          :isRequired="true"
          @blur="checkPhone"
        ></theme-input> 
        <div class="mt-2" v-if="!!is_phone_number_unique">
            <span class="text-[#FF695B] text-[12px]">{{ phoneNumberAlreadyExists }}</span>
            <input type="hidden" name="phone_number_unique" v-validate="`required`" />
        </div>

      </div>


      <div>
        <theme-input
          :label="subscriptionsEmail"
          :name="subscriptionsEmailInput"
          @blur="checkMail"
          class="js-unique-mail"
          :placeholder="subscriptionsEmailPlaceholder"
          :value="email"
          v-validate="`required|email`"
          :isRequired="true"
        ></theme-input>

        <div class="mt-2" v-if="is_user_already_exists == 1">
          <span class="text-[#FF695B] text-[12px]">{{ isUserAlreadyExists }}</span>
          <input type="hidden" name="user_already_exists" v-validate="`required`" />
        </div>

        <div class="mt-2" v-else-if="is_user_already_exists == 2">
          <span class="text-[#FF695B] text-[12px]">{{ isUserBanned }}</span>
          <input type="hidden" name="user_already_exists" v-validate="`required`" />
        </div>
      </div>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-6">
        <theme-input
          :label="subscriptionsPassword"
          :name="subscriptionsPasswordInput"
          type="password"
          ref="password0"
          :placeholder="subscriptionsPasswordPlaceholder"
          v-validate="`required`"
          :isRequired="true"
        ></theme-input>
        
        
        <theme-input
          :label="subscriptionsPasswordRepeat"
          type="password"
          :name="subscriptionsPasswordRepeatInput"
          :placeholder="subscriptionsPasswordRepeatPlaceholder"
          v-validate="`required|confirmed:password0`"
          :isRequired="true"
        ></theme-input> 
      </div>

      <div 
        v-if="number_of_adults_value > 1"
        v-for="adult in number_of_adults_value_computed - 1"
        :key="adult"
      >
        <registration-inner-form
          :i="adult"
          :users-first-name="subscriptionsFirstName"
          :users-first-name-placeholder="subscriptionsFirstNamePlaceholder"
          :users-middle-name="subscriptionsMiddleName"
          :users-middle-name-placeholder="subscriptionsMiddleNamePlaceholder"
          :users-last-name="subscriptionsLastName"
          :users-last-name-placeholder="subscriptionsLastNamePlaceholder"
          :users-date-of-birth="subscriptionsDateOfBirth"
          :users-date-of-birth-placeholder="subscriptionsDateOfBirthPlaceholder"
          :users-phone-number="subscriptionsPhoneNumber"
          :users-phone-number-placeholder="subscriptionsPhoneNumberPlaceholder"
          :users-email="subscriptionsEmail" 
          :users-email-placeholder="subscriptionsEmailPlaceholder" 
          :isUserAlreadyExists="isUserAlreadyExists"
          :isUserBanned="isUserBanned"
          :phoneNumberAlreadyExists="phoneNumberAlreadyExists"
        ></registration-inner-form>

      </div>

      <!-- :options="{ '1': subscribeToNewsletter }" -->
      <theme-checkboxes
        class="form__radio"
        :options="{ '1': `${agreeWithConditionsText} <a href=${generalTermsLink} target='_blank' class='text-[#FF8212] hover:underline'>${generalTermsLinkText}</a><span class='theme-input__label-asterisk'>*</span>` }"
        :name="'terms_conditions'"
        v-validate="`required`"
        :isRequired="true"
      ></theme-checkboxes>

      <button
        id="submitFormBtn"
        class="theme-btn theme-btn--theme theme-btn--block"
        type="submit"
        @click.prevent="submitForm"
      >
        {{ commonCreateAccount }}
      </button>

    </div>
  </div>
</template>

<script>
import ThemeInput from "./ThemeInput.vue";
import ThemeCheckboxes from "./ThemeCheckboxes.vue";
import ThemeRadios from "./ThemeRadios.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import ThemeToggler from "./ThemeToggler.vue";
import ThemeLocationDropdown from "./ThemeLocationDropdown.vue";

import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ThemeInput,
    ThemeCheckboxes,
    ThemeRadios,
    ThemeCalendar,
    ThemeToggler,
    ThemeLocationDropdown,
  },
  props: {
    subscriptionsFormTitle: {
      default: "",
      type: String,
    },
    subscriptionsFirstName: {
      default: "",
      type: String,
    },
    subscriptionsFirstNameInput: {
      default: "",
      type: String,
    },
    subscriptionsFirstNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsMiddleName: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNameInput: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsLastName: {
      default: "",
      type: String,
    },
    subscriptionsLastNameInput: {
      default: "",
      type: String,
    },
    subscriptionsLastNamePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumber: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumberInput: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyName: {
      default: "",
      type: String,
    },
    companyNameInput: {
      default: "",
      type: String,
    },
    companyNamePlaceholder: {
      default: "",
      type: String,
    },
    companyLegalForm: {
      default: "",
      type: String,
    },
    companyLegalFormInput: {
      default: "",
      type: String,
    },
    companyLegalFormPlaceholder: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumber: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberInput: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyVatNumber: {
      default: "",
      type: String,
    },
    companyVatNumberInput: {
      default: "",
      type: String,
    },
    companyVatNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyPhoneNumber: {
      default: "",
      type: String,
    },
    companyPhoneNumberInput: {
      default: "",
      type: String,
    },
    companyPhoneNumberPlaceholder: {
      default: "",
      type: String,
    },
    companyEmail: {
      default: "",
      type: String,
    },
    companyEmailInput: {
      default: "",
      type: String,
    },
    companyEmailPlaceholder: {
      default: "",
      type: String,
    },
    companyInvoiceEmail: {
      default: "",
      type: String,
    },
    companyInvoiceEmailInput: {
      default: "",
      type: String,
    },
    companyInvoiceEmailPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsFamilyTypeSlugs: {
      default: () => {},
      type: Object,
    },
    subscriptionsFamilyTypeInput: {
      default: "",
      type: String,
    },
    subscriptionsFamilyTypeInputTitle: {
      default: "",
      type: String,
    },
    subscriptionsFamilyTypeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionNumberOfAdults: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdultsValue: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdultsPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsEmail: {
      default: "",
      type: String,
    },
    subscriptionsEmailInput: {
      default: "",
      type: String,
    },
    subscriptionsEmailPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsPassword: {
      default: "",
      type: String,
    },
    subscriptionsPasswordInput: {
      default: "",
      type: String,
    },
    subscriptionsPasswordPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsPasswordRepeat: {
      default: "",
      type: String,
    },
    subscriptionsPasswordRepeatInput: {
      default: "",
      type: String,
    },
    subscriptionsPasswordRepeatPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsYourDetails: {
      default: "",
      type: String,
    },
    subscriptionsYourRentalPreferences: {
      default: "",
      type: String,
    },
    commonCreateAccount: {
      default: '',
      type: String,
    },
    subscriptionsDateOfBirth: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirthInput: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirthPlaceholder: {
      default: "",
      type: String,
    },
    businessLabel: {
      default: "",
      type: String,
    },
    subscribeToNewsletter: {
      default: "",
      type: String,
    },
    websiteId: {
      default: "",
      type: String,
    },
    businessTitle: {
      default: "",
      type: String,
    },
    spCityTitle: {
			default: '',
			type: String
		},
    firstName: {
			default: '',
			type: String
		},
    lastName: {
			default: '',
			type: String
		},
    email: {
			default: '',
			type: String
		},
    facebookId: {
			default: '',
			type: String
		},
    generalTermsLink: {
      default: '#',
      type: String
    },
    generalTermsLinkText: {
      default: '',
      type: String
    },
    agreeWithConditionsText: {
      default: '',
      type: String
    },
    isUserAlreadyExists: {
      default: '',
      type: String
    },
    isUserBanned: {
      default: '',
      type: String
    },
    phoneNumberAlreadyExists: {
      default: '',
      type: String
    },
  },
  data() {
    return {
      family_type_state: null,
      number_of_adults_value: this.subscriptionNumberOfAdultsValue,
      business_state: "0",
      is_user_already_exists: 0,
      is_phone_number_unique: 0,

      isSubmitInProgress: false,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    number_of_adults_value_computed: function () {
      if (this.number_of_adults_value >= 1) {
        return this.number_of_adults_value;
      } else {
        return 1;
      }
    },
    stepNumber: function() {
      return this.$store.state.registrationStep.stepNumber;
    }
    // business_form_state: {
    //   get: function () {
    //     if (this.business_state != "") {
    //       return this.business_state;
    //     } else {
    //       if (this.websiteId != 2) {
    //         return this.business_state_false;
    //       } else {
    //         return this.business_state_true;
    //       }
    //     }
    //   },
    //   set: function (newValue) {
    //     if (newValue) {
    //       this.business_state = newValue;
    //     }
    //   },
    // },
  },
  methods: {
    website: function () {
      if (this.websiteId != 2) {
        return "athome";
      } else {
        return "staffhousing";
      }
    },
    changeStepNumber(value) {
      this.$store.commit('CHANGE_STEP_NUMBER', value);
    },
    changeBusinessRegistration(value) {
      this.$store.commit('CHANGE_BUSINESS_REGISTRATION', value);
    },
    changeAdutlsNumber(value) {
      this.$store.commit('CHANGE_ADULTS_NUMBER', value);
    },
    triggerAdultsNumber(event) {
      event > 1 ? this.changeAdutlsNumber(event) : this.changeAdutlsNumber(1)
    },
    triggerBusinessForm: function (value) {
      if (value == '1')  this.number_of_adults_value = 1;
      this.business_state = value;
      this.changeBusinessRegistration(value);
    },
    triggerFamilyType: function (value) {
      if (value) {
        console.log(value);
        this.family_type_state = this.subscriptionsFamilyTypeSlugs[value];
        // this.changeAdutlsNumber(this.number_of_adults_value_computed);
      } 
      if (this.family_type_state == "living_together") {
        this.number_of_adults_value = 2;
        this.changeAdutlsNumber(2);
      }
      if (this.family_type_state == "single") {
        this.number_of_adults_value = 1;
        this.changeAdutlsNumber(1);
      }
      if (this.family_type_state == "several_friends") {
        this.number_of_adults_value = this.subscriptionNumberOfAdultsValue;
        this.changeAdutlsNumber(1);
      }
    },
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          // Go to the next step
          this.changeStepNumber(1);
          window.scrollTo({ top: 0, behavior: 'smooth'});
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
    checkMail: function (event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email,
        },
        success: function (result) {
          var elements = document.getElementsByClassName("js-unique-mail"),
            mails = [];

          Array.prototype.forEach.call(elements, function (el) {
            let val = el.querySelector("input").value;
            if (el.querySelector("input") != event.target && val != "") {
              mails.push(val);
            }
          });

          if (parseInt(result) === 1) {
            vm.is_user_already_exists = 1;
          } else {
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
      } else {
        vm.is_phone_number_unique = 0;
      }
    },
  },

  beforeMount() {
  },
};
</script>


// WEBPACK FOOTER //
// resources/js/components/RegistrationForm.vue